import React from 'react';
import './SearchAndFilters.css';

const SearchAndFilters = ({ searchQuery, onSearchChange, onRefresh }) => {
  return (
    <div className="search-filters-row">
      <div className="search-container">
        <span className="search-icon">🔍</span>
        <input
          type="text"
          className="search-input"
          placeholder="Search by Order ID, Customer name, Phone..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <div className="filters-container">
        <button className="filter-btn">
          <span className="filter-icon">📅</span>
          Filter by Date
        </button>
        <button className="filter-btn">
          Amount: All
          <span className="dropdown-arrow">▼</span>
        </button>
        <button className="refresh-btn" onClick={onRefresh} title="Refresh">
          🔄
        </button>
      </div>
    </div>
  );
};

export default SearchAndFilters;

